import type { ReactNode } from 'react'

import { cn } from '@/lib/utils'
import { article as articleUi } from '@/shared/lib/articleStyles'
import { ArticleRailCta } from '@/shared/ui/ArticleRailCta'

type ArticleReadingLayoutProps = {
    intro?: ReactNode
    toc: ReactNode
    children: ReactNode
    showRailCta?: boolean
}

/**
 * Mobile: intro → toc (+ CTA) → body.
 * Desktop (md+): sticky left rail (toc + CTA) parallel to intro + body.
 */
export function ArticleReadingLayout({
    intro,
    toc,
    children,
    showRailCta = true,
}: ArticleReadingLayoutProps) {
    return (
        <div className={articleUi.readingLayout}>
            {intro ? <div className={articleUi.readingIntro}>{intro}</div> : null}
            <aside className={articleUi.readingTocRail}>
                {toc}
                {showRailCta ? <ArticleRailCta /> : null}
            </aside>
            <div className={cn(articleUi.readingBody, !intro && articleUi.readingBodyNoIntro)}>{children}</div>
        </div>
    )
}
